import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const Integrations = () => <PublicStaticPage pageKey="integrations" />;

export default Integrations;
